<script lang="ts">
  import type { Filter } from "@shared/types/Filters";

  export let updateFilter;
  export let filter;
  export let filters: Filter[];
  export let checked;

  const isChecked = val => {
    if (!checked) {
      return false;
    }
    return (Array.isArray(checked) ? checked : [checked]).includes(val);
  };

  const onChange = e => updateFilter(filter, { id: e.target.value });

  const up = filters.find(f => f.id == "1");
  const down = filters.find(f => f.id == "-1");

</script>

<div class="fizz-card side-filter fizz-inset-vertical-8">
  <details class="fizz-accordion" open={true}>
    <summary class="side-filter-header">
      <span class="fizz-heading-6">Next Month's Pricing</span>
    </summary>
    <div class="fizz-inset-horizontal-16 fizz-flow-8">
      <dl class="fizz-overflow-y side-filter__list">
        <dt class="side-filter__item fizz-stack-8">
          <p>
            <small>Filter products with at least 1 size where price is changing next month.</small>
          </p>
        </dt>
        {#if up}
          <dt class="side-filter__item">
            <label class="fizz-flex-row-8 fizz-stack-4 cursor-pointer" for="pricing-going-up">
              <input
                type="checkbox"
                class="fizz-checkbox"
                name="price_up"
                value="1"
                id="pricing-going-up"
                checked={isChecked("1")}
                on:change={onChange}
              />
              <span class="side-filter-list-item icon-arrow-up">Price going up</span>
              <span class="fizz-text-subdued" style="margin-left: auto">({up.count})</span>
            </label>
          </dt>
        {/if}
        {#if down}
          <dt class="side-filter__item">
            <label class="fizz-flex-row-8 fizz-stack-4 cursor-pointer" for="pricing-going-down">
              <input
                type="checkbox"
                class="fizz-checkbox"
                name="price_down"
                value="-1"
                id="pricing-going-down"
                checked={isChecked("-1")}
                on:change={onChange}
              />
              <span class="side-filter-list-item icon-arrow-down">Price going down</span>
              <span class="fizz-text-subdued" style="margin-left: auto">({down.count})</span>
            </label>
          </dt>
        {/if}
      </dl>
    </div>
  </details>
</div>
